import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChecked = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.32695 4.63803C2.99997 5.27976 2.99997 6.11984 2.99997 7.8V16.2C2.99997 17.8802 2.99997 18.7202 3.32695 19.362C3.61457 19.9265 4.07351 20.3854 4.638 20.673C5.27973 21 6.11981 21 7.79997 21H16.2C17.8801 21 18.7202 21 19.3619 20.673C19.9264 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9264 3.6146 19.3619 3.32698C18.7202 3 17.8801 3 16.2 3H7.79997C6.11981 3 5.27973 3 4.638 3.32698C4.07351 3.6146 3.61457 4.07354 3.32695 4.63803ZM16.2556 9.11398C15.9041 8.76251 15.3343 8.76251 14.9828 9.11398L10.2192 13.8776L8.58648 12.2449C8.23501 11.8934 7.66516 11.8934 7.31369 12.2449C6.96221 12.5963 6.96221 13.1662 7.31369 13.5177L9.58281 15.7868C9.93428 16.1382 10.5041 16.1382 10.8556 15.7868L16.2556 10.3868C16.6071 10.0353 16.6071 9.46546 16.2556 9.11398Z",
		fill: "currentColor"
	})
});
export default SvgChecked;
